import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Box, Card, Avatar, Button, useTheme } from '@material-ui/core';
import DashboardRoundedIcon from '@material-ui/icons/DashboardRounded';
import { IdeaCss } from '../IdeaCss';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import { useIdeaDetailsController } from '../../../containers/IdeaDetailsPage/hooks/useIdeaDetailsController';
import { ReactComponent as ValuePropositionCanvasIcon } from '../../../assets/imgs/icon-valuepropositioncanvas.svg';

export function IdeaCanvas({ handleOnOpenValueCanvas, handleOnOpenCanvas }) {
  const theme = useTheme();
  const classes = IdeaCss();
  const { t } = useTranslation();
  const { hasIdeaFlux } = useIdeaDetailsController();

  function isFillCanvas(canvas) {
    if (!!canvas.length) {
      const hasAnswer = canvas.map((item) => item.answer?.length).some((length) => length > 0);
      return hasAnswer;
    };
    return false
  };

  return (
    <Grid item xs={12}>
      <Card elevation={0} className={classes.cardSmall}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Avatar className={classes.avatarIcon}>
                <DashboardRoundedIcon color="primary" fontSize="small" />
              </Avatar>
              <Typography variant="subtitle1">{t('canvas')}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            {isFillCanvas(hasIdeaFlux.canvasValueProposition) && (
              <Button
                onClick={handleOnOpenValueCanvas}
                className={classes.buttonCanvas}
                startIcon={<ValuePropositionCanvasIcon style={{ fill: theme.palette.neutrals.low.dark }} />}
              >
                Value Proposition Canvas
              </Button>
            )}
            {isFillCanvas(hasIdeaFlux.canvas) && (
              <Button
                onClick={handleOnOpenCanvas}
                className={classes.buttonCanvas}
                startIcon={<DashboardOutlinedIcon style={{ fontSize: 24 }} />}
              >
                Business Model Canvas
              </Button>
            )}
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}
